// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationMenu_wrapper__10Gp9","content":"NavigationMenu_content__2td-Z"};